import { ITemplatePlaceHolderControlContent } from '@fi-app/template/template';
import { IFiCustomerData } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { TemplateControlType } from '@fi-app/template/types/template-control-type';

export class TemplatePlaceHolderControlModel {
    Id: number;
    PlaceHolderId: number;
    ControlType: TemplateControlType;
    Properties: string;
    Content: any;
    Settings: {
        lock: boolean;
        Columns;
        SortOrder: number;
        columnClass?: string;
    };
    Contents: ITemplatePlaceHolderControlContent[];

    constructor(customerData: IFiCustomerData, data?) {
        data = data || {};

        this.Id = data.Id;
        this.PlaceHolderId = data.PlaceHolderId;
        this.ControlType = data.ControlType;
        this.Properties = '';
        this.Content = data.Content;
        this.Settings = typeof data.Settings == 'string' ? JSON.parse(data.Settings) : data.Settings || {};
        this.Contents = [];
        customerData.ContentLanguages.forEach((item) => {
            var Content: any = {
                ContentLanguageId: item.Id,
                Value: {},
            };
            (data.Contents || []).forEach((content) => {
                if (content.ContentLanguageId == item.Id) {
                    Content.Value = typeof content.Value == 'string' ? JSON.parse(content.Value) : content.Value || {};
                    Content.Id = content.Id;
                    Content.PlaceHolderControlId = content.PlaceHolderControlId;
                    Content.ContentLanguageLabelObjectType = content.ContentLanguageLabelObjectType;
                    Content.ControlType = content.ControlType;
                }
            });
            this.Contents.push(Content);
        });
    }
}
